import router from '@/router';
import { api } from "@/store";
import { jwtDecode } from "jwt-decode";

const PREBOOKING_KEY = "pb_token";

export default {
    createToken(payload) {
        localStorage.setItem(PREBOOKING_KEY, payload.token);
    },
    removeToken() {
        localStorage.removeItem(PREBOOKING_KEY);
    },
    getToken() {
        const token = localStorage.getItem(PREBOOKING_KEY);
        return token ? jwtDecode(token) : null;
    },
    isTokenExpired() {
        const token = this.getToken()
        if (!token)
            return true
        return (new Date(token.exp) * 1000) <= new Date();
    },
    async prebook(facilityId, payload) {
        await api.post('/prebook/facility/' + facilityId, payload)
            .then(response => {
                const res = response.data
                if (res.status == "success") {
                    this.removeToken()
                    router.push('/booking/' + res['prebooking_id'])
                    return
                } else {
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'error',
                        icon_color: 'text-danger',
                        title: 'Désolé!',
                        detail: res['message']
                    })
                    router.push('/search')
                }
            }).catch(error => {
                if (error.response) {
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'error',
                        icon_color: 'text-danger',
                        title: 'Désolé!',
                        detail: error.response.status >= 500 ? 'Une erreur est survenue! Veuillez réessayer plus tard.' : error.response.data.detail
                    })
                    if (error.response.data?.detail?.error_information) {
                        router.push('/my/profile')
                        return
                    }
                }
            })
    }
}